import React, { useEffect } from 'react';
import { Link, Redirect } from 'react-router-dom';
import Footer from '../Footer/Footer';
import { Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

function About(props) {
  const classes = useStyles();
  const sendEmail = (e) => {
    e.preventDefault();
    window.emailjs
      .sendForm(
        'default_service',
        'template_1ewbltc',
        e.target,
        'user_XOlCl0ufWTjmhLIBVREYN'
      )
      .then(
        (result) => {
          alert('Thank You. We will contact you soon')
          props.history.push("/")
        },
        (error) => {
          alert('Something went wrong. Please try after sometime')
        }
      );
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (1 === !1) return <Redirect to="/" />;
  return (
    <div>
      <div style={{ marginBottom: '0px', backgroundColor: 'rgb(1, 160, 90)' }}>
        <div
          className="container py-5"
          style={{ marginTop: '3.4em', marginBottom: '0px' }}
        >
          <div className="row h-100 align-items-center py-5">
            <div className="col-lg-6">
              <Typography variant="h1" style={{ textAlign: "left", color: 'white', fontSize: "72px", fontWeight: "900" }}>A Logistics Solution Built For Your Business</Typography>
              <Typography variant="span"
                className="lead mb-0"
                style={{ textAlign: 'left', color: 'white', justifyContent: "left", display: "flex", fontWeight: "600" }}
              >
                We Do Deliveries Faster, Cheaper And Better
              </Typography>
            </div>
            <div className="col-lg-6 d-none d-lg-block">
              <Paper elevation={3} style={{ padding: '4%', borderRadius: '20px' }} >
                <form className="contact-form" onSubmit={sendEmail}>
                  <input
                    type="text"
                    name="user_name"
                    placeholder="Your Fullname"
                  />
                  <input
                    type="text"
                    name="contact_number"
                    placeholder="Your Phone Number"
                  />
                  <input
                    type="email"
                    name="user_email"
                    placeholder="Your E-mail"
                  />
                  <input type="hidden" name="subject" placeholder="Subject" value="Logistics Enquiry email" />
                  <textarea
                    placeholder="Message"
                    name="message"
                    defaultValue={''}
                  />
                  <button
                    type="submit"
                    style={{
                      height: '45px',
                      paddingTop: '12px',
                      background: 'rgb(1, 160, 90)',
                      border: '1px solid rgb(1, 160, 90)',
                      color: '#fff',
                      borderRadius: '15px',
                    }}
                    className="btnAdd site-btn"
                  >
                    CONTACT NOW
                  </button>
                </form>
              </Paper>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white py-5">
        <div className="container py-5">
          <div className="row align-items-center mb-5">
            <div className="col-lg-12 col-sm-12">
              <Typography variant="h4" style={{ textAlign: "left", color: 'black', fontWeight: "800" }}>HOW IT WORKS</Typography>
            </div>
          </div>
          <div className="row align-items-center mb-5">
            <div className="col-lg-6 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/step1.png"
                alt=""
                width="450"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
            <div className="col-lg-6 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/step2.png"
                alt=""
                width="450"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "left" }}>Choose your Pick up Location </Typography>
              <Typography variant="p" className="text-dark mb-4" style={{ textAlign: "left", display: "flex", fontWeight: "600" }}>
                Choose the location of your shop.
              </Typography>
            </div>
            <div className="col-lg-6">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "left" }}>Choose your Drop Location and Pay</Typography>
              <Typography variant="p" className="text-dark mb-4" style={{ textAlign: "left", display: "flex", fontWeight: "600" }}>
                Choose the delivery location and pay the amount. Our system will assign one delivery partner for you who will deliver the item.
              </Typography>
            </div>
          </div>
        </div>
      </div>
      <div className="py-5" style={{ backgroundColor: "rgb(29, 36, 60)", display: "none" }}>
        <div className="container py-5">
          <div className="row align-items-center mb-5">
            <div className="col-lg-12 col-sm-12">
              <Typography variant="h4" style={{ textAlign: "left", color: 'white' }}>HOW TO GET STARTED</Typography>
            </div>
          </div>
          <div className="row align-items-center mb-5">
            <div className="col-lg-4 col-sm-4">
              <Typography variant="p" style={{ textAlign: "left", color: 'white', display: "flex", fontWeight: "bold" }}>Sign Up</Typography>
            </div>
            <div className="col-lg-4 col-sm-4">
              <Typography variant="p" style={{ textAlign: "left", color: 'white', display: "flex", fontWeight: "bold" }}>Download the Driver app</Typography>
            </div>
            <div className="col-lg-4 col-sm-4">
              <Typography variant="p" style={{ textAlign: "left", color: 'white', display: "flex", fontWeight: "bold" }}>Earn Money</Typography>
            </div>
            <br></br>

            <div className="col-lg-4 col-sm-4">
              <Typography variant="p" style={{ textAlign: "left", color: 'white', display: "flex" }}>Create an account, upload your documents, and complete a short screening call with a member of our team</Typography>
            </div>
            <div className="col-lg-4 col-sm-4">
              <Typography variant="p" style={{ textAlign: "left", color: 'white', display: "flex" }}>Set your availability within the driver app and pick up any avialable open runs that works for you</Typography>
            </div>
            <div className="col-lg-4 col-sm-4">
              <Typography variant="p" style={{ textAlign: "left", color: 'white', display: "flex" }}>Once you have all the tools you need, you can start making deliveries to earn extra cash.</Typography>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white py-5" style={{ display: "none" }}>
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <Typography variant="h4" className="font-weight-bold" style={{ textAlign: "left" }}>Questions</Typography>
            </div>
          </div>
          <br></br>
          <br></br>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>How do I earn money with Grospick</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    As an independent contractor you can earn money by making deliveries
                    via the Grospick platform. You are paid for deliveries done from our partner
                    merchants to our customers.
          </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
            <div className="col-lg-6">
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>When do I get paid?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    You will get paid on a weekly basis. We provide you with a detailed summary of
                    all the deliveries you complete and how much you made for each. This is
                    available via our app and courier portal.
          </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
          <br></br>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>What equipment do I need?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography style={{ paddingLeft: '5%', textAlign: "left" }}>
                    As an independent contractor, you’re responsible for providing and
                    maintaining your own equipment including:
                    <ul>
                      <li>
                        Something to get around on a roadworthy car, motorbike or scooter,
                        registered and CTP insured. You’ll also need a full driver’s licence.
                      </li>
                      <li>Something to wear, while you can wear what you want, it’s very
                      important you provide an excellent impression to customers and
                      merchants alike. We’d like you to dress neatly and not wear clothing which
                      contain words/slogans which might oend. Also, safety is important and
                      you’ll need a strong helmet and protective clothing if you’re riding a
                      motorbike/scooter.
                      </li>
                      <li>Something compatible with our driver app, either ‘iOS’ or ‘Android’
                      mobile phone, a charger so your battery doesn’t run at and a data plan
                      </li>
                      <li>Something to to carry deliveries in,delivery quality is essential to us all.
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
            <div className="col-lg-6">
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>Any vehicle requirements?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    Your vehicle needs to be a 1990 model or newer, registered and CTP
                    insured. You also need a full driver’s license.
          </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
          <br></br>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>How much money do I make?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    As an independent Grospick courier you earn money through your delivery
                    fee which is based o distance and driving time. This will all be explained
                    further as part of onboarding.

                    Unlike other services, Grospick does not take a commission on your fees -
                    you keep the money you make.
          </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
            <div className="col-lg-6">
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>How am I allocated deliveries?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    Our advanced technology system matches your availability and location
                    with the exact time delivery will be ready to collect from one of the many
                    busy merchant partners – this makes the most ecient use of everyone’s
                    time and means on time deliveries.
          </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
          <br></br>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>When can I get started?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    You can start making deliveries on our network once you complete the
                    signup process, provide all the correct documents, participate in a quick
                    screening call with a member of our team, and have all of the required
                    equipment.
          </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
            <div className="col-lg-6">
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>What does it mean to be an independent
contractor?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    As a courier on the Grospick network, it means you have the freedom to
                    choose when you can work, how often you work and how much you earn.
                    You are under no obligation to provide any services to us and you are also
                    free to work for other businesses.
          </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default About;
